import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLockOpen = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 9,
			width: 16,
			height: 12,
			rx: 4,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 16L12 14",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6667 5.14229C14.9035 5.48217 15.3709 5.56575 15.7108 5.32899C16.0507 5.09222 16.1343 4.62476 15.8975 4.28489L15.2821 4.71359L14.6667 5.14229ZM8.27819 4.04862C8.02082 4.37318 8.07528 4.84492 8.39984 5.10228C8.72439 5.35965 9.19613 5.30519 9.4535 4.98064L8.86584 4.51463L8.27819 4.04862ZM8 9H8.75V7H8H7.25V9H8ZM8 7H8.75C8.75 5.20508 10.2051 3.75 12 3.75V3V2.25C9.37665 2.25 7.25 4.37665 7.25 7H8ZM15.2821 4.71359L15.8975 4.28489C15.331 3.4717 14.5244 2.85606 13.5905 2.52421L13.3394 3.23091L13.0883 3.93762C13.7272 4.16467 14.2791 4.5859 14.6667 5.14229L15.2821 4.71359ZM13.3394 3.23091L13.5905 2.52421C12.6567 2.19236 11.6424 2.16091 10.6898 2.43426L10.8967 3.15517L11.1036 3.87607C11.7554 3.68904 12.4493 3.71056 13.0883 3.93762L13.3394 3.23091ZM10.8967 3.15517L10.6898 2.43426C9.73722 2.70762 8.89397 3.27209 8.27819 4.04862L8.86584 4.51463L9.4535 4.98064C9.87482 4.44933 10.4518 4.06311 11.1036 3.87607L10.8967 3.15517Z",
			fill: "currentColor"
		})
	]
});
export default SvgLockOpen;
